<template>
	<div class="pageContainer app-container studentContainer">
		<el-row>


			<el-link style="margin-left: 20px; margin-right: 20px;" type="primary" @click="downFeeXls">下载考生导入模板</el-link>
			
			<el-upload style="display: inline-block; margin-right: 20px;" action=""
				:http-request="uploadTemp" :on-success="uploadFiles" :show-file-list="false"
				name="image">
				<el-button size="small" icon="el-icon-upload"  plain type="primary">上传学生名单</el-button>
			</el-upload>
			
			<el-button size="small" icon="el-icon-printer" v-print="'#printMe'" plain type="primary">打印准考证</el-button>

		</el-row>
		<el-row style="margin-top: 20px">
		</el-row>


		<el-tabs v-model="activeName" type="card" >
			<el-tab-pane label="点击上方[上传名单]" name="first">
				
			</el-tab-pane>

		</el-tabs>
		
		
		<div>
			<div style="text-align:center">提示：如需导出PDF，点击打印按钮，另存为PDF即可，提示：打印预览将缩放调至130或1.3</div>
			<!-- <div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
			</div> -->
			<div style="width: 800px; min-height: 800px; border: 1px solid #ccc; margin: 0 auto;">
				<div id="printMe" style=" width: 650px; margin: 0 auto; ">
					<div style="width:325px;height:450px;overflow: hidden; display: inline-block; vertical-align: top;"
						v-for="(stu, idx) in StuList" :key="idx">
						<div class="zong" v-html="stu.html"></div>
					</div>
			
				</div>
			</div>
			
		</div>
		
		
		
		
		
		


	</div>
</template>
<script>
	export default {

		data() {
			return {
				activeName: "first",
				StuList:[],
				temHtml:""
			}
		},


		mounted() {
			this.getTemp()

		},
		methods: {
			
			getTemp(){
				this.$http.post("/api/t_sch_printer_list", { ktype: "ptype", keyword: "zkz" }).then(res => {
					this.temHtml = res.data[0].pjson
				})
			},
			downFeeXls(){
				window.open("/xls/学生准考证模板.xlsx","_blank")
			},
			uploadFiles(e){
				this.$http.post("/api/import_stu_zkz", {
					url: e.src
				}).then(res => {
					
					
					for (let stu of res.data) {
						let printHtml = this.temHtml
						stu.otherjson = JSON.parse(stu.otherjson)
						printHtml = printHtml.replace(/\${学生编号}/g, stu.stu_code)
						printHtml = printHtml.replace(/\${学生姓名}/g, stu.stu_name)
						printHtml = printHtml.replace(/\${院系}/g, stu.yuanxi_name)
						printHtml = printHtml.replace(/\${专业}/g, stu.major_name)
						printHtml = printHtml.replace(/\${学制}/g, stu.xuezhi)
						printHtml = printHtml.replace(/\${今日日期}/g, this.date)
						printHtml = printHtml.replace(/\${考试号}/g, stu.exam_num)
						printHtml = printHtml.replace(/\${建档号}/g, stu.archive)
						printHtml = printHtml.replace(/\${学生性别}/g, stu.gender == 1 ? '男' : '女')
						printHtml = printHtml.replace(/\${准考证号}/g, stu.exam_num)
						printHtml = printHtml.replace(/\${分数}/g, stu.exam_score)
						printHtml = printHtml.replace(/\${学生电话}/g, stu.phone)
						printHtml = printHtml.replace(/\${学生电话2}/g, stu.phone2)
						printHtml = printHtml.replace(/\${报道须知号}/g, stu.fee_idx)
						printHtml = printHtml.replace(/\${缴费序号}/g, stu.fee_idx)
						printHtml = printHtml.replace(/\${身份证号}/g, stu.identity_card)
						//专业二是否缴费
						let zyerok =false
						if(stu.major_name2){
							printHtml = printHtml.replace(/\${专业二}/g, stu.major_name2?stu.major_name2:'')
							zyerok = true
						}
						if(!zyerok){
							printHtml = printHtml.replace(/\${专业二}/g,'')
								
						}
						
						printHtml = printHtml.replace(/\${电子照片}/g,"<img src='" + stu.otherjson.dzzj+"' />")
					
						stu.html = printHtml
					}
					
					this.StuList = res.data
					
					
				})
			}
		}
	}
</script>

<style scoped>
	.zong {
		transform: scale(0.407, 0.407);
		transform-origin: left top;
	}
</style>